module.exports = __webpack_public_path__ + "static/media/sm.c4ee42b3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sm.svg
// module id = 981
// module chunks = 0